import Review01Desktop from "@/assets/images/review-01-desktop-eng.png";
import Review01Mobile from "@/assets/images/review-01-mobile-eng.png";
import Review02Desktop from "@/assets/images/review-02-desktop-eng.png";
import Review02Mobile from "@/assets/images/review-02-mobile-eng.png";
import Review03Desktop from "@/assets/images/review-03-desktop-eng.png";
import Review03Mobile from "@/assets/images/review-03-mobile-eng.png";
import Review04Desktop from "@/assets/images/review-04-desktop-eng.png";
import Review04Mobile from "@/assets/images/review-04-mobile-eng.png";
import Review05Desktop from "@/assets/images/review-05-desktop-eng.png";
import Review05Mobile from "@/assets/images/review-05-mobile-eng.png";
import Review06Desktop from "@/assets/images/review-06-desktop-eng.png";
import Review06Mobile from "@/assets/images/review-06-mobile-eng.png";
import { Spacer } from "@/components/Spacer";
import { motion, useInView } from "framer-motion";
import { useEffect, useRef, useState } from "react";

export default function Section01({ isMobile }: { isMobile: boolean }) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: "0px 0px -20% 0px",
    amount: 0.0,
  });

  return (
    <div className="flex flex-col items-center desktop:py-[100px] py-[80px] bg-[#F5F6FA]">
      <motion.div
        id="section-01-01"
        ref={ref}
        className="font-eng-01-semibold desktop:text-[34px] text-[24px] text-[#17191C] leading-[130%] text-center"
        initial={{ opacity: 0, y: 30 }}
        animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
        transition={{
          type: "spring",
          stiffness: 300,
          damping: 100,
          mass: 1,
          delay: 0.2,
        }}
        style={{ letterSpacing: "-0.0em" }}
      >
        {'"'}Healthier alleviated <br className="desktop:hidden block" /> my
        vague concerns
        <br />
        about potential illnesses
        {'"'}
      </motion.div>
      <Spacer height={isMobile ? 0 : 20} />
      <Carousel isMobile={isMobile} />
    </div>
  );
}

interface CarouselProps {
  isMobile: boolean;
}

const Carousel = ({ isMobile }: CarouselProps) => {
  const images = isMobile
    ? [
        Review01Mobile,
        Review02Mobile,
        Review03Mobile,
        Review04Mobile,
        Review05Mobile,
        Review06Mobile,
      ]
    : [
        Review01Desktop,
        Review02Desktop,
        Review03Desktop,
        Review04Desktop,
        Review05Desktop,
        Review06Desktop,
      ];

  // 두 배의 이미지를 생성하여 무한 스크롤 효과 구현
  const duplicatedImages = [...images, ...images];

  return (
    <div className="relative w-full overflow-hidden">
      {/* 클리핑 뷰포트 - 25% 너비로 제한 */}
      <div className="relative w-full overflow-hidden">
        {/* 페이드 효과를 위한 좌측 그라디언트 */}
        <div className="absolute top-0 left-0 desktop:h-[326px] h-[386px] w-[15%] z-10 bg-gradient-to-r from-[#F5F6FA] to-transparent pointer-events-none"></div>

        <div className="flex items-center py-8 overflow-hidden">
          <motion.div
            className="flex gap-[20px]"
            animate={{
              x: [
                0,
                -(images.length * (isMobile ? 360 : 520) + images.length * 20),
              ],
            }}
            transition={{
              x: {
                repeat: Infinity,
                repeatType: "loop",
                duration: images.length * 7, // 속도 50%에 해당하는 적절한 지속 시간
                ease: "linear",
              },
            }}
          >
            {duplicatedImages.map((image, index) => (
              <motion.div
                key={index}
                className={`${
                  isMobile ? "w-[360px] h-[310px]" : "w-[520px] h-[281px]"
                } flex-shrink-0 overflow-hidden`}
                // whileHover={{ scale: 1.02 }}
                transition={{ duration: 0.3 }}
              >
                <img src={image} alt={`리뷰 ${(index % images.length) + 1}`} />
              </motion.div>
            ))}
          </motion.div>
        </div>

        {/* 페이드 효과를 위한 우측 그라디언트 */}
        <div className="absolute top-0 right-0 h-full w-[15%] z-10 bg-gradient-to-l from-[#F5F6FA] to-transparent pointer-events-none"></div>
      </div>
    </div>
  );
};
